import React, { Component } from "react";

export default class Uitleg extends Component {
  render() {
    return (
      <div style={{ margin: "50px" }}>
        <p>
          Overzichten dynamisch gemaakt qua datum keuze

          10 oktober 2025
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Uitleg.jsx